var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSum3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#E66100"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4219_60574)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 34.0943C12 33.7173 12.31 33.4118 12.6925 33.4118C14.6042 33.4118 16.1539 31.8844 16.1539 30.0002C16.1539 28.1159 14.6042 26.5883 12.6925 26.5883C12.31 26.5883 12 26.2827 12 25.906V19.0823C12 18.7056 12.31 18.4 12.6925 18.4H47.3075C47.69 18.4 48 18.7056 48 19.0823V25.906C48 26.2827 47.69 26.5883 47.3075 26.5883C45.3958 26.5883 43.8461 28.1159 43.8461 30.0002C43.8461 31.8844 45.3958 33.4118 47.3075 33.4118C47.69 33.4118 48 33.7173 48 34.0943V40.9178C48 41.2947 47.69 41.6 47.3075 41.6H12.6925C12.31 41.6 12 41.2947 12 40.9178V34.0943ZM39.0001 22.494C39.3826 22.494 39.6926 22.1884 39.6926 21.8117C39.6926 21.4348 39.3826 21.1292 39.0001 21.1292C38.6179 21.1292 38.3079 21.4348 38.3079 21.8117C38.3079 22.1884 38.6179 22.494 39.0001 22.494ZM39.0001 25.2233C39.3826 25.2233 39.6926 24.918 39.6926 24.5411C39.6926 24.1641 39.3826 23.8588 39.0001 23.8588C38.6179 23.8588 38.3079 24.1641 38.3079 24.5411C38.3079 24.918 38.6179 25.2233 39.0001 25.2233ZM39.0001 27.953C39.3826 27.953 39.6926 27.6474 39.6926 27.2704C39.6926 26.8937 39.3826 26.5882 39.0001 26.5882C38.6179 26.5882 38.3079 26.8937 38.3079 27.2704C38.3079 27.6474 38.6179 27.953 39.0001 27.953ZM39.0001 30.6823C39.3826 30.6823 39.6926 30.3767 39.6926 30C39.6926 29.6231 39.3826 29.3175 39.0001 29.3175C38.6179 29.3175 38.3079 29.6231 38.3079 30C38.3079 30.3767 38.6179 30.6823 39.0001 30.6823ZM39.0001 33.4116C39.3826 33.4116 39.6926 33.1063 39.6926 32.7293C39.6926 32.3524 39.3826 32.0471 39.0001 32.0471C38.6179 32.0471 38.3079 32.3524 38.3079 32.7293C38.3079 33.1063 38.6179 33.4116 39.0001 33.4116ZM39.0001 36.1412C39.3826 36.1412 39.6926 35.8356 39.6926 35.4587C39.6926 35.082 39.3826 34.7764 39.0001 34.7764C38.6179 34.7764 38.3079 35.082 38.3079 35.4587C38.3079 35.8356 38.6179 36.1412 39.0001 36.1412ZM39.0001 38.8706C39.3826 38.8706 39.6926 38.565 39.6926 38.1883C39.6926 37.8113 39.3826 37.5057 39.0001 37.5057C38.6179 37.5057 38.3079 37.8113 38.3079 38.1883C38.3079 38.565 38.6179 38.8706 39.0001 38.8706ZM27.2313 25.2232C27.2313 23.7159 25.9915 22.4939 24.4619 22.4939C22.9326 22.4939 21.6927 23.7159 21.6927 25.2232C21.6927 26.7308 22.9326 27.9528 24.4619 27.9528C25.9915 27.9528 27.2313 26.7308 27.2313 25.2232ZM21.8446 36.3973C21.6055 36.6917 21.6539 37.1209 21.9526 37.3565C22.2511 37.5918 22.6869 37.5442 22.9256 37.25L34.0023 23.6026C34.2414 23.3085 34.193 22.879 33.8943 22.6437C33.5958 22.4081 33.16 22.4557 32.9213 22.7502L21.8446 36.3973ZM34.1541 34.7766C34.1541 33.2693 32.9142 32.0472 31.3849 32.0472C29.8554 32.0472 28.6155 33.2693 28.6155 34.7766C28.6155 36.2839 29.8554 37.5059 31.3849 37.5059C32.9142 37.5059 34.1541 36.2839 34.1541 34.7766Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4219_60574",
    x: 9,
    y: 18.4,
    width: 42,
    height: 30.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4219_60574"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4219_60574",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSum3);
export default __webpack_public_path__ + "static/media/sum-3.f6d46dcee8ccd237398ce21d318adddc.svg";
export { ForwardRef as ReactComponent };